<template>
  <ul class="nav navbar-nav navbar-with-inside clearfix navbar-right with-border">
    <li v-for="item in menuData" :key="item.categoryId" class="dropdown">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
        aria-expanded="false">
        {{ item.categoryName }}
      </a>
      <!-- 只在有子菜单时显示下拉菜单内容 -->
      <ul class="dropdown-menu" v-if="item.children && item.children.length">
        <li v-for="child in item.children" :key="child.categoryId">
          <a :href="child.path || '#'">{{ child.categoryName }}</a>
          <!-- 如果子菜单项也有子菜单，则递归调用自身 -->
          <menu-tree v-if="child.children && child.children.length" :menu-data="child.children" />
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'MenuTree',
  props: {
    menuData: Array
  },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/MenuTree.vue